export { default } from './PasswordTextInput'
